import { Fragment, ReactNode } from 'react';

import { Box } from 'components/Box';
import { Icon } from 'components/Icon';
import { RouterLink } from 'components/Link';
import { Text } from 'components/Text/Text';

type Link = {
  'data-qa-id'?: string;
  title: ReactNode;
  to?:
    | string
    | {
        pathname: string;
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        state: Record<string, any>;
      };
};

type Props = {
  'data-qa-id'?: string;
  links: Array<Link>;
};

export function Breadcrumbs({ links, ...props }: Props) {
  return (
    <Box
      component={Text}
      styleAs="bodySmall"
      display="flex"
      alignItems="center"
      data-qa-id="breadcrumbs"
      whiteSpace="nowrap"
      overflow="hidden"
      textOverflow="ellipsis"
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    >
      {links.map(({ title, to, ...linkProps }, index) => (
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/no-array-index-key
        <Fragment key={index}>
          {index > 0 && (
            <Box mx={10}>
              <Icon
                initialColorName="todo-replace-me"
                name="chevron-left"
                size={11}
              />
            </Box>
          )}
          <Box
            component={to ? RouterLink : undefined}
            to={to || undefined}
            maxWidth={[
              `calc((100% - ${31 * (links.length - 0.5)}px) / ${
                links.length - 1
              })`,
              null,
              'none',
            ]}
            whiteSpace="nowrap"
            overflow="hidden"
            textOverflow="ellipsis"
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...linkProps}
          >
            {index < links.length - 1 ? (
              title
            ) : (
              <>
                <Box display={['none', null, 'inline']}>{title}</Box>
                <Box display={['inline', null, 'none']}>
                  <Box
                    dangerouslySetInnerHTML={{
                      __html: '&hellip;',
                    }}
                  />
                </Box>
              </>
            )}
          </Box>
        </Fragment>
      ))}
    </Box>
  );
}
